import type { ReactNode } from 'react';
import { EmailInboxCard } from '../artifacts/email/EmailInboxArtifact';
import { parseEmailInboxPayload } from '../artifacts/email/email-inbox-payload';
import {
  OobEvidenceLabel,
  OobInteractionsCard,
} from '../artifacts/oob/OobInteractionsCard';
import { parseOobEvidencePayload } from '../artifacts/oob/oob-evidence-payload';
import { WebSocketTranscriptCard } from '../artifacts/websocket/WebSocketTranscriptCard';
import { parseWebSocketEvidencePayload } from '../artifacts/websocket/websocket-session-payload';
import type { TraceEvidence } from './trace-types';
import { EvidenceCardWithData } from './EvidenceCardWithData';

export function renderProtocolEvidenceCard({
  evidence,
  index,
  actions,
}: {
  evidence: TraceEvidence;
  index: number;
  actions?: ReactNode;
}): ReactNode | null {
  const evidenceType = evidence.type?.toUpperCase();
  const oobPayload =
    evidenceType === 'OOB' ? parseOobEvidencePayload(evidence.data) : undefined;

  if (oobPayload) {
    return (
      <EvidenceCardWithData
        key={`evidence-${index}`}
        explanation={evidence.explanation}
        actions={actions}
        index={index}
        evidenceType="oob"
        detail={<OobEvidenceLabel payload={oobPayload} />}
      >
        <OobInteractionsCard payload={oobPayload} />
      </EvidenceCardWithData>
    );
  }

  const webSocketPayload =
    evidenceType === 'WEBSOCKET' || evidence.data
      ? parseWebSocketEvidencePayload(evidence.data)
      : undefined;

  if (webSocketPayload) {
    return (
      <EvidenceCardWithData
        key={`evidence-${index}`}
        explanation={evidence.explanation}
        actions={actions}
        index={index}
        evidenceType="websocket"
      >
        <WebSocketTranscriptCard payload={webSocketPayload} />
      </EvidenceCardWithData>
    );
  }

  const emailPayload =
    evidenceType === 'EMAIL' || evidence.data
      ? parseEmailInboxPayload(evidence.data)
      : undefined;

  if (emailPayload) {
    return (
      <EvidenceCardWithData
        key={`evidence-${index}`}
        explanation={evidence.explanation}
        actions={actions}
        index={index}
        evidenceType="email"
      >
        <EmailInboxCard payload={emailPayload} />
      </EvidenceCardWithData>
    );
  }

  return null;
}
